<table class="skeleton-table mat-elevation-z0">
  <thead>
    <tr>
      <th *ngFor="let column of displayedColumns">
        <div class="skeleton-table-element">
          <div class="skeleton-line skeleton-line-header"></div>
        </div>
      </th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let row of [1,2,3,4]">
      <td *ngFor="let column of displayedColumns">
        <div class="skeleton-table-element">
          <div class="skeleton-line"></div>
        </div>
      </td>
    </tr>
  </tbody>
</table>